import { FC, PropsWithChildren } from "react";

const Badge : FC<PropsWithChildren> = ({ children }) =>
  <div className="absolute flex justify-center items-center bg-primary text-white rounded-full top-[-8px] right-[-8px] p-1 text-xs w-5 h-5">
    {children}
  </div>;

export default Badge;
